// import the react components
import React from "react";

// the dashboard card functional based component
const DashboardCard = ({label, value, sub, icon}) => {
    return (
        <div className="flex-1 min-w-[180px] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-5 flex flex-col gap-2.5">
            <div className="w-10 h-10 rounded-lg bg-primary dark:bg-blue-950 flex items-center justify-center text-white text-xl">{icon}</div>
            <p className="text-sm text-gray-400">{label}</p>
            <p className="text-2xl font-medium text-gray-900 dark:text-gray-50">{value}</p>
        </div>
    );
};
export default DashboardCard;